let UpsellInsuranceType = /*#__PURE__*/function (UpsellInsuranceType) {
  UpsellInsuranceType["PACKLINK_INSURANCE"] = "PACKLINK_INSURANCE";
  UpsellInsuranceType["NO_INSURANCE"] = "NO_INSURANCE";
  UpsellInsuranceType["STANDARD"] = "STANDARD";
  UpsellInsuranceType["ENHANCED"] = "ENHANCED";
  UpsellInsuranceType["PROOF_OF_DELIVERY"] = "PROOF_OF_DELIVERY";
  return UpsellInsuranceType;
}({});
let InsuranceTitle = /*#__PURE__*/function (InsuranceTitle) {
  InsuranceTitle["BULK"] = "insurance-selector.title-insurance-card.bulk";
  InsuranceTitle["PACKLINK_INSURANCE"] = "insurance-selector.title-insurance-card.add-shipment-protection";
  InsuranceTitle["NO_INSURANCE"] = "insurance-selector.title-insurance-card.no-insurance";
  InsuranceTitle["STANDARD"] = "insurance-selector.title-insurance-card.standard-number";
  InsuranceTitle["PROOF_OF_DELIVERY"] = "insurance-selector.title-insurance-card.proof-of-delivery";
  InsuranceTitle["ENHANCED"] = "insurance-selector.title-insurance-card.add-shipment-protection";
  return InsuranceTitle;
}({});
let InsuranceBenefit = /*#__PURE__*/function (InsuranceBenefit) {
  InsuranceBenefit["REFUND_LOSS"] = "insurance-selector.benefits-list.full-refund-loss";
  InsuranceBenefit["REFUND_DAMAGE"] = "insurance-selector.benefits-list.full-refund-damage";
  InsuranceBenefit["SECOND_HAND"] = "insurance-selector.benefits-list.second-hand";
  InsuranceBenefit["COMPENSATION"] = "insurance-selector.benefits-list.compensation";
  InsuranceBenefit["STANDARD_COMPENSATION"] = "insurance-selector.benefits-list.standard-compensation";
  InsuranceBenefit["SIGNATURE"] = "insurance-selector.benefits-list.requires-signature";
  return InsuranceBenefit;
}({});

export { InsuranceBenefit, InsuranceTitle, UpsellInsuranceType };
//# sourceMappingURL=upsell.js.map
